import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';

import dibsCss from 'dibs-css';

const SellerApplicationBusinessConfirmation: FC = () => (
    <div className={classnames(dibsCss.minH600px, dibsCss.textCenter)}>
        <div className={dibsCss.sassyFontHeader}>
            <FormattedMessage
                id="SellerApplicationForm.consignorsDetails.header"
                defaultMessage="Thank you for submitting!"
            />
        </div>
    </div>
);

export default SellerApplicationBusinessConfirmation;
